// it's ugly, but we support window.netdata* properties anyway (for static custom-dashboards)
// perhaps it's TODO
window.netdataTheme = "white"
window.netdataNoBootstrap = true
